import { Box, Button, Container, TextField, Autocomplete, Switch, Typography, Stack, Divider } from "@mui/material";
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { AddStock } from './index';

const Stocks = ({ stores, stocks, errors, prices, onChangeField, onAddNew, onRemoveNew }) => {
  return (<>
    <Stack direction="column" spacing={2} gap={2} marginY={3} divider={<Divider variant="middle" />} >
      {stocks && stocks.map((stock, index) => {
        return (
          <AddStock
            index={index}
            stores={stores}
            quantity={stock.quantity}
            store={stock.store_id}
            s={stock?.store}
            error={errors}
            prices={stock.prices_new}
            defaultPrices={prices}
            onChange={(field, newValue) => {
              onChangeField(field, newValue);
            }}
          />)
      })}
    </Stack>
    <Box display='flex' justifyContent='space-between'>
      {stocks?.length >= 2 && <Button endIcon={<RemoveCircle />} onClick={onRemoveNew}>
        Quitar
      </Button>}
      <Button endIcon={<AddCircle />} onClick={onAddNew}>
        Nuevo
      </Button>
    </Box>
  </>
  )
}

export default Stocks;